import $ from 'jquery'

let ktableSpiele;
let ktableFragen;

function callbackDoReflow(ktable, index) {
    if (typeof ktable != 'undefined') {
        ktable.doReflow(index);
    }
}

window.addEventListener('DOMContentLoaded', function () {
    $('#ranking').tippuebersicht();
    const tabelleSpiele = $("#spielplanSpiele");
    if (tabelleSpiele.length) {
        ktableSpiele = tabelleSpiele.ktable().data('ktable');
        ktableSpiele.rowheader(['liga', 'termin'],
            {
                reflowCallback: function () {
                    callbackDoReflow(ktableFragen, 0);
                }
            });
        ktableSpiele.stack(['heim', 'gruppe'],
            {
                prependTablehead: true
            });
        ktableSpiele.stack(['heim', 'punkteregel'],
            {
                prependTablehead: true
            });
        ktableSpiele.stack(['heim', 'gast']);
        ktableSpiele.shrink(['heim']);
        ktableSpiele.overflow(['heim']);
        ktableSpiele.prepare();
    }

    const tabelleFragen = $("#spielplanFragen");
    if (tabelleFragen.length) {
        ktableFragen = tabelleFragen.ktable().data('ktable');
        ktableFragen.rowheader(['termin'],
            {
                reflowCallback: function () {
                    callbackDoReflow(ktableSpiele, 0);
                }
            });
        ktableFragen.stack(['frage', 'liga'],
            {
                prependTablehead: true
            });
        ktableFragen.stack(['frage', 'punkteregel'],
            {
                prependTablehead: true
            });
        ktableFragen.stack(['frage', 'kurzfrage'],
            {
                prependTablehead: true
            });
        ktableFragen.stack(['frage', 'ergebnis']);
        ktableFragen.wrap(['frage']);
        ktableFragen.prepare();
    }
    if (tabelleSpiele.length) {
        ktableSpiele.reflow();
    }
    if (tabelleFragen.length) {
        ktableFragen.reflow();
    }
});
